import { isEmpty } from 'lodash';

import { sendMessage } from 'genesys/genesys';

import messages from './messages';

const CO_BROWSE = 'CoBrowse';
const CO_BROWSE_OFFERING = 'Offering';

const contentActions = {
  Message: sendMessage,
};

const normalizeQuickReply = ({ action, payload, text }) => ({
  action: contentActions[action],
  payload,
  text,
});

const contentNormalizer = {
  QuickReply: normalizeQuickReply,
};

const actionNormalize = ({ contentType, quickReply }) =>
  contentNormalizer[contentType](quickReply) ?? {};

export const getEventClaims = (event, setCoBrowseActioned, safelabel) => {
  if (
    !isEmpty(event) &&
    event.eventType === CO_BROWSE &&
    event.coBrowse?.type === CO_BROWSE_OFFERING
  ) {
    setCoBrowseActioned(false);

    return {
      message: safelabel(messages.coBrowseReply),
      eventClaims: {
        coBrowse: {
          ...event?.coBrowse,
          actioned: false,
        },
      },
    };
  }
};

export const getContentClaims = (content) => {
  if (!isEmpty(content) && content.length) {
    return {
      content: content.map(actionNormalize),
    };
  }
};

export const getRestoreQuickReplyClaim = (quickReplies) => {
  if (!isEmpty(quickReplies) && quickReplies.length) {
    return {
      content: quickReplies.map((item) =>
        actionNormalize({
          contentType: 'QuickReply',
          quickReply: item,
        }),
      ),
    };
  }
};
